import ENV from 'scaleflow/config/environment';

const allowedDomains = ENV.ALLOWED_API_DOMAINS?.split?.(',') ?? [
  'scaleflow.com',
];

const domainName = (): string => {
  const host = window.location.host;
  const splitHost = host.split('.');
  splitHost.splice(0, 1);
  const domain = splitHost.join('.');
  if (allowedDomains.includes(domain)) return domain;
  return allowedDomains[0]!;
};

export const apiEndpoint = () => {
  const domain = domainName();
  const endpoint = ENV.API_ENDPOINT.replace('<domain>', domain);
  return endpoint;
};

export const wsEndpoint = () => {
  const domain = domainName();
  const endpoint = ENV.WSS_ENDPOINT.replace('<domain>', domain);
  return endpoint;
};
